import Link from 'next/link'
import FollowButton from 'shared/components/users/FollowButton'
import RoundedAvatarImage from './avatar/RoundedAvatarImage'
import classNames from 'classnames'
import NameWithVerificationBadge from './display/NameWithVerificationBadge'

type Props = {
  avatar?: string | null
  username: string
  fullName: string
  userId: number
  isFollowing: boolean
  isVerified?: boolean
  isProUser?: boolean
  isPremiumUser?: boolean
}

const FollowableItemUI = (props: Props) => {
  const {
    avatar,
    username,
    fullName,
    isVerified = false,
    isProUser = false,
    isPremiumUser = false,
    isFollowing,
    userId,
  } = props
  return (
    <div className="pb-0 pt-2 text-base">
      <div className="flex items-center justify-between border-b px-2 pb-3 lg:px-4">
        <div className="flex gap-3">
          <Link
            passHref
            href={`/${username}/profile`}
            className="relative size-10 focus:outline-none focus:ring-0 lg:size-12"
          >
            <RoundedAvatarImage
              className="h-full w-full !border-black/10"
              src={avatar}
              alt={username || 'user avatar'}
            />
          </Link>
          <div className="flex flex-1 flex-col justify-center gap-0 lg:gap-2">
            <Link
              passHref
              href={`/${username}/profile`}
              className="cursor-pointer text-sm font-medium capitalize leading-none text-black hover:underline lg:text-base"
            >
              <NameWithVerificationBadge
                username={username}
                fullName={fullName}
                isVerified={isVerified || false}
                isProUser={isProUser || false}
                isPremiumUser={isPremiumUser || false}
                className={classNames(
                  'text-xs font-medium capitalize leading-none text-[#191414] ',
                  username && 'cursor-pointer hover:underline',
                )}
                maxNameLength={-1}
              />
            </Link>
            <span className="text-[10px] text-black/60 lg:text-xs">@{username}</span>
          </div>
        </div>

        <FollowButton userId={userId} isFollowingInitial={isFollowing} fullWidth={false} fullName={fullName} />
      </div>
    </div>
  )
}

export default FollowableItemUI
